import styled from '@emotion/styled'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`
